import configs from "../configs/apiConfigs";
import { METHOD_TYPE, BODY_TYPE, CommonApiOptions } from "../constants/api";
import { commonApi } from "../helpers/api";
import { attachHeader } from "../utils/apiHandler";

const BASE_URL = `${configs.SOURCE_URL}concierges_driven`;

const buildQuery = (params: Record<string, any>) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, String(value));
    }
  });
  return query.toString();
};

export const getClinicList = (params: {
  source: string;
  city: string;
  domain: string;
  zone: string;
  searchcity: string;
}) => {
  const request: CommonApiOptions = {
    url: `${BASE_URL}/cliniclist/`,
    method: METHOD_TYPE.POST,
    body: {
      type: BODY_TYPE.RAW,
      data: params,
    },
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };
  return commonApi(request);
};

export const saveLandingPage = (params: {
  source: string;
  city: string;
  domain: string;
  zone: string;
  clinicIds: string;
}) => {
  const request: CommonApiOptions = {
    url: `${BASE_URL}/save-paid-ads-url/`,
    method: METHOD_TYPE.POST,
    body: {
      type: BODY_TYPE.RAW,
      data: params,
    },
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };
  return commonApi(request);
};

/** `domain` should be the domain display name (e.g. "Dental"), not numeric id. */
export const getLandingPagesList = (params: {
  page: number;
  record: number;
  domain?: string;
  city?: string;
}) => {
  const request: CommonApiOptions = {
    url: `${BASE_URL}/paid-ads-clinic-list/?${buildQuery(params)}`,
    method: METHOD_TYPE.GET,
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };
  return commonApi(request);
};

export const getLandingPageDomains = () => {
  const request: CommonApiOptions = {
    url: `${BASE_URL}/domains/`,
    method: METHOD_TYPE.GET,
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };
  return commonApi(request);
};

export const getLandingPageCities = (domain: string | number) => {
  const request: CommonApiOptions = {
    url: `${BASE_URL}/cities/?${buildQuery({ domain })}`,
    method: METHOD_TYPE.GET,
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };
  return commonApi(request);
};
